import { realtimeMarketsTimeSeriesTransform } from '../transforms/markets/time-series';
import { CHART_DATA_TYPE } from '../transforms/markets/common';

import { extend } from '../../util/jquery.js';

export default class RealtimeTimeSeries {
    constructor(option) {
        this.securityManager = option.securityManager;
        this.apiManager = option.apiManager;
        this.map = new Map();
    }
    getInstruments(securities) {
        let instrument;
        securities.map(security => {
            instrument = `${instrument},${security.quoteInstrument}`;
            this.map.set(security.quoteInstrument, security.queryKey);
        });
        return instrument.replace(/undefined,/g, '');
    }
    async price(params) {
        const securities = await this.securityManager.create(params.securities);
        const instruments = this.getInstruments(securities);
        if (instruments.length > 0) {
            const _params = {
                tickers: instruments,
                days: params.tradingDays,
                f: params.frequency,
                sd: params.sdate,
                ed: params.edate
            };
            if (/\d+/.test(params.frequency)) {
                if (params.sdate || params.edate) {
                    _params.cdt = CHART_DATA_TYPE.REALTIME_INTRADAY_RANGE;
                    extend(_params, {
                        st: params.stime,
                        et: params.etime
                    });
                } else {
                    _params.cdt = CHART_DATA_TYPE.REALTIME_INTRADAY_LAST;
                }
            } else {
                _params.cdt = CHART_DATA_TYPE.REALTIME_HISTORICAL;
            }

            const data = await this.apiManager.timeSeriesRealtimeMarkets(
                _params
            );
            return realtimeMarketsTimeSeriesTransform(data, params, this.map);
        } else {
            throw this.securityManager.getInvalidSecuritiesError(
                params.security
            );
        }
    }
}
